import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { MODULE_LAYOUT_LABELS } from "entities/modules/constants";
import { ModuleLayout, PromotionModuleLayout } from "entities/modules/types";
import CardCarouselPlaceholder from "entities/modules/widgets/CardCarouselPlaceholder";
import CardGridViewPlaceholder from "entities/modules/widgets/CardGridViewPlaceholder";
import CardWithPlaceholder from "entities/modules/widgets/CardWithPlaceholder";
import ThreeCardBlockPlaceholder from "entities/modules/widgets/ThreeCardBlockPlaceholder";
import { useGeneralData } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/stores/useGeneralData";
import { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";

const ModuleLayoutSection: FC = () => {
  const { moduleLayout, setModuleLayout } = useGeneralData();

  const handleLayoutSelect = (layout: ModuleLayout) => () => {
    setModuleLayout(layout);
  };

  return (
    <ContentSection title="MODULE LAYOUT">
      <Stack spacing="1rem">
        <Box display="flex" width="100%" gap="0.5rem">
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[PromotionModuleLayout.GridView]}
            isActive={moduleLayout === PromotionModuleLayout.GridView}
            placeholder={<CardGridViewPlaceholder />}
            onSelect={handleLayoutSelect(PromotionModuleLayout.GridView)}
          />
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[PromotionModuleLayout.HorizontalScroll]}
            isActive={moduleLayout === PromotionModuleLayout.HorizontalScroll}
            placeholder={<ThreeCardBlockPlaceholder />}
            onSelect={handleLayoutSelect(
              PromotionModuleLayout.HorizontalScroll,
            )}
          />
          <CardWithPlaceholder
            text={MODULE_LAYOUT_LABELS[PromotionModuleLayout.FeaturedCarousel]}
            isActive={moduleLayout === PromotionModuleLayout.FeaturedCarousel}
            placeholder={<CardCarouselPlaceholder />}
            onSelect={handleLayoutSelect(
              PromotionModuleLayout.FeaturedCarousel,
            )}
          />
        </Box>
      </Stack>
    </ContentSection>
  );
};

export default ModuleLayoutSection;
